import React, {
    forwardRef, useMemo, useCallback
} from 'react';
import PropTypes from 'prop-types';

import { Tracking } from 'bdvp-tracking';

import { useMediaConfig } from '../../../hooks/config';
import {
    SEARCH_ROUTE,
    QUERY_PARAMS,
    CarouselRowType,
} from '../../../utils/constants';

import RowHeading from '../../RowHeading';
import { PersonalizedModuleV1 as PersonalizedModule } from '../../PersonalizedModule';

const carouselType = CarouselRowType.PERSONALIZED_V1;

const PersonalizedRow = forwardRef((props, ref) => {

    const {
        title,
        teamId,
        teamName,
        teamLogoImageTemplateUrl,
        backgroundImageTemplateUrl,
        overlayStyles,
        playerImageTemplateUrl,
        players,
        loading,
        rank,
    } = props;

    const {
        teamPlayersEditLink = '/account/favorites',
    } = useMediaConfig();

    const teamLink = `${SEARCH_ROUTE}?${QUERY_PARAMS.query}=TeamId == [${teamId}] Order By Timestamp DESC`;
    const formattedPlayers = useMemo(() => {

        const playersArray = players?.map(({
            id, lastName, name,
        }) => ({
            id,
            lastName,
            name,
            to: `${SEARCH_ROUTE}?${QUERY_PARAMS.query}=PlayerId == [${id}] Order by Timestamp DESC`,
        })) ?? [];
        playersArray.push({
            as: 'a',
            href: teamPlayersEditLink,
        });
        return playersArray;

    }, [
        players,
        teamPlayersEditLink,
    ]);

    const onItemClickHandler = useCallback(({
        id, index, type,
    }) => {

        Tracking.trackCarouselOnItemClick({
            carouselRank: rank,
            carouselTitle: title,
            index,
            id,
            carouselType,
            type,
        });

    }, [
        rank,
        title,
    ]);

    const onAfterChangeHandler = useCallback((isScrollLeft) => {

        Tracking.trackCarouselScroll({
            carouselRank: rank,
            carouselTitle: title,
            isScrollLeft,
            carouselType,
        });

    }, [
        rank,
        title,
    ]);

    return (
        <div ref={ref}>
            <RowHeading
                text={title}
                loading={loading}
                enableLeftRightMargin
            />
            <PersonalizedModule
                loading={loading}
                teamId={teamId}
                teamName={teamName}
                teamLink={teamLink}
                teamLogoImageTemplateUrl={teamLogoImageTemplateUrl}
                backgroundImageTemplateUrl={backgroundImageTemplateUrl}
                overlayStyles={overlayStyles}
                playerImageTemplateUrl={playerImageTemplateUrl}
                players={formattedPlayers}
                onItemClick={onItemClickHandler}
                onAfterChange={onAfterChangeHandler}

            />
        </div>
    );

});

PersonalizedRow.propTypes = {
    rank: PropTypes.number.isRequired,
    title: PropTypes.string,
    teamId: PropTypes.number,
    teamName: PropTypes.string,
    teamLogoImageTemplateUrl: PropTypes.string,
    backgroundImageTemplateUrl: PropTypes.string,
    overlayStyles: PropTypes.string,
    playerImageTemplateUrl: PropTypes.string,
    players: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            lastName: PropTypes.string,
            name: PropTypes.string,
        })
    ),
    loading: PropTypes.bool,
};

export default PersonalizedRow;
